import PropTypes from 'prop-types'
import React from 'react'
import Youtube from 'react-youtube'
import Content from '../content'
import './style.scss'

const Video = ({ src, transcript, title }) => (
  <div>
    <div className="iframeContainer">
      <Youtube videoId={src} id="tubeplayer" />
    </div>
    <details className="transcript">
      <summary>Näytä tekstivastine{title ? `: ${title}` : ''}</summary>
      <Content content={transcript} />
    </details>
  </div>
)

Video.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string,
  transcript: PropTypes.string,
}

Video.defaultProps = {
  src: '',
  title: '',
  transcript: '',
}

export default Video
